import { useEffect, useState } from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import useAuth from "src/hooks/useAuth";
import v2_actionCredenciais from "src/actions/v2/cliente/v2_actionCredenciais";
import { useNavigate } from "react-router";

const CardSendMake = ({ block, changeBlock }) => {
  const { cliente } = useAuth();
  const navigate = useNavigate()
  //upload
  const [listaWebhooks, setListaWebhooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchWebhooks, setSearchWebhooks] = useState(null);

  const getListWebhooksMale = async () => {
    try {
      let querys = `?source=make`
      setLoading(true)
      const response = await v2_actionCredenciais(cliente._id, querys);
      const acticve = response.data.data.filter((item) => item.status === true)
      setListaWebhooks(acticve)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
    setSearchWebhooks(true)
  }

  useEffect(() => {
    getListWebhooksMale()
  }, []);

  return (
    <div className="w-full">
      <div className="space-y-4 flex flex-col gap-4">
      {/* Canal de envio */}
      {listaWebhooks.length === 0 ? (
        <div className="text-xs">
          <h4>Você ainda não possui webhooks do Make configurado na plataforma.</h4>
          <p>
            Clique <a 
            onClick={
              () => navigate('/dashboard/configuracoes/integracoes')
            }
            className="text-blue-500 underline cursor-pointer">aqui</a> para cadastrar
          </p>
        </div>
      ) : (
        listaWebhooks.length > 0 ? (
          <div>
          <label className="block text-sm font-medium">Webhook</label>
          <Select
            value={block?.data?.chatChannel}
            onValueChange={e => {
              console.log('e', e)
              let event = {
                name: "webhookMake",
                value: {
                  id: e._id,
                  url: e.keys?.url
                }
              }
              changeBlock(event)
            }}
            className="w-full"
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Selecione um webhook" />
            </SelectTrigger>
            <SelectContent>
              {listaWebhooks.map((i) => (
                <SelectItem key={i._id} value={i}>
                  {i?.keys?.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        ) : (
          searchWebhooks && (
            <div className="text-xs">
            <h4>Você ainda não possui webhooks do Make configurado na plataforma.</h4>
            <p className="mt-2">
              Clique <a 
              onClick={
                () => navigate('/dashboard/configuracoes/make')
              }
              className="text-blue-500 underline cursor-pointer">aqui</a> para cadastrar
            </p>
          </div>
          )

        )
      
      )}


      </div>
    </div>
  );
};

export default CardSendMake;
